export default __webpack_public_path__ + "4d7f39fbb40377d4aa2a41bf531d378b.png";